/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { FaMinusCircle, FaPlusCircle } from "react-icons/fa";
import { v4 as uuidv4 } from "uuid";
import { useTranslation } from "react-i18next";
import ButtonLink from "./buttonLink";
import LoadingSmall from "./loadingSmall";
import Select from "./select";
import Spacer from "./spacer";
import RebrandButtonLink from "./rebrandButtonLink";

function MultipleSelect(props) {
	const { t } = useTranslation();
	const {
		value,
		onChange,
		valueKey,
		placeholder,
		required,
		addAnotherText,
		name,
		type,
		error,
		onBlur = () => {},
		className,
		options,
		customLabel,
	} = props;

	const [items, setItems] = useState(null);

	if (!items && !value) {
		setItems([
			{
				id: uuidv4(),
				[valueKey]: null,
			},
		]);
	}

	if (!items && value) {
		const itemArray = value.map((v) => ({ ...v, id: uuidv4() }));
		setItems(itemArray);
	}

	const updateOnChange = (newItems) => {
		setItems(newItems);
		// remove ids to return object to orginal state
		const copy = JSON.parse(JSON.stringify(newItems));
		copy.forEach((item) => {
			delete item.id;
		});
		onChange(copy);
	};

	const onChangeItem = ({ id, val }) => {
		const item = items.find((i) => i.id === id);
		item[valueKey] = val;

		updateOnChange(items);
	};

	const remove = (id) => {
		const newItems = items.filter((n) => n.id !== id).slice();
		updateOnChange(newItems);
	};

	const addAnother = () => {
		const newItems = items.slice();
		newItems.push({
			id: uuidv4(),
			[valueKey]: null,
		});
		updateOnChange(newItems);
	};
	if (!items) {
		return <LoadingSmall />;
	}
	return (
		<div className={`${className}`}>
			{items?.map((v, i) => (
				<div key={`item${v.id}`}>
					<div
						className={`relative  block w-full border-0 rounded-lg shadow-sm`}
					>
						<Select
							customLabel={customLabel}
							required
							className='select-search font-sentric-alt text-base'
							id={`btn${name}`}
							name={name}
							placeholder={placeholder}
							value={v[valueKey]}
							onChange={(item) => onChangeItem({ id: v.id, val: item })}
							options={
								options && v[valueKey] === null
									? options.filter(
											(o) => !items.map((j) => j[valueKey]).includes(o.value)
									  )
									: options || []
							}
							search
						/>
					</div>
					{items.length > 1 && (
						<div className='flex justify-end text-sm'>
							<button
								className='text-black hover:scale-105 transition-all duration-150 items-center h-4 underline mt-2'
								type='button'
								onClick={() => remove(v.id)}
							>
								<span className='ml-2'>{t("common:remove")}</span>
							</button>
						</div>
					)}
					<Spacer thin />
				</div>
			))}
			{!!error && (
				<p className='inline-block w-4/5 p-1 pl-3 pr-3 mt-2 text-sm text-white bg-red-700 border border-white rounded-lg'>
					{error}
				</p>
			)}

			<div className='flex items-center justify-end w-full h-4 mt-4'>
				<RebrandButtonLink plusIcon onClick={addAnother} id={`txt${name}`}>
					{addAnotherText}
				</RebrandButtonLink>
			</div>
		</div>
	);
}

export default MultipleSelect;
